import React from 'react';

// Material UI
import Paper from '@mui/material/Paper';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import { Divider } from '@mui/material';


// Import our store

// API
import ThreeColumnContent from '../components/core/ThreeColumnContent';
import Navbar from '../components/core/Navbar';
import SearchForm from '../components/search/SearchForm';
import Footer from '../components/core/Footer';
import StandardView from '../components/core/StandardView';

// Types
interface Props {

}

const SearchPage = ({}: Props) => {

  const SearchFormHeader = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.h3,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

  const SearchFormSubHeader = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.h5,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

  const SearchFormContent = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.h5,
    textAlign: 'left',
    padding:'8px',
    color: theme.palette.text.secondary,
  }));

  return (
    <StandardView>
      <SearchForm/>
    </StandardView>
  );
};

export default SearchPage;